import ServiceItem from './service-item';

export default ServiceItem;
